import { Colors } from '@estee/elc-base-theme';

export const tabHeaderTheme = `
    background-color: transparent;
    border-color: ${Colors.primary300};

    &:hover,
    &:focus {
        border-color: ${Colors.black};
        cursor: pointer;
    }

    &.elc-tabs__tab--current {
        border-color: ${Colors.black};

        &:hover,
        &:focus {
            cursor: default;
        }
    }

    .elc-icon {
        cursor: inherit;
    }
`;
